import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Header } from "app/components/header";
import { Footer } from "app/components/footer";
import Container from "@mui/material/Container";
import { colors, customBreakpointsMax } from "app/theme";
import ResponsiveCTAs from "app/components/responsive-ctas";
import Typography from "@mui/material/Typography";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { AssistanceLaptop } from "app/assets/vectors/jsx/AssistanceLaptop";

export const ErrorBoundary: React.FC = () => {
  return (
    <React.Fragment>
      <Header />
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingBottom: "50px",
          minHeight: "calc(100vh - 52px - 277px)",
          [customBreakpointsMax.tablet]: {
            padding: "0 30px",
            paddingBottom: "40px",
          },
          [customBreakpointsMax.mobile]: {
            padding: "0 24px",
            paddingBottom: "20px",
          },
        }}
      >
        <Box id="main">
          <Box
            sx={{
              padding: "20px",
              fontSize: "1.2rem",
              color: "text.primary",
              textAlign: "flex-start",
            }}
          >
            <Box
              sx={{
                padding: "36px 0",
                display: "flex",
                gap: "50px",
                alignItems: "center",
                [customBreakpointsMax.tablet]: {
                  gap: "31px",
                  "> svg": {
                    width: "223px",
                    height: "116px",
                  },
                },
                [customBreakpointsMax.mobile]: {
                  flexDirection: "column-reverse",
                  gap: "20px",
                  "> svg": {
                    width: "183px",
                    height: "95px",
                  },
                },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                }}
              >
                <Typography
                  variant="h1"
                  fontSize={{
                    xs: "24px",
                    lg: "36px",
                  }}
                  lineHeight={"normal"}
                >
                  It seems like you have encountered an error.
                </Typography>
                <Typography
                  marginTop={"10px"}
                  color={colors.text.title}
                  fontSize={{
                    xs: "14px",
                    lg: "18px",
                  }}
                  lineHeight={"24px"}
                  fontWeight={"400"}
                >
                  Hi there, it seems like something went wrong. Our team of
                  experts is here to help you.
                  <br />
                  Contact us through the assistance button in the bottom right
                  corner or return to the home page.
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: "30px",
                    marginTop: "30px",
                    "> button, > a": {
                      fontSize: "18px",
                      padding: "10px 15px",
                      lineHeight: "normal",
                    },
                    [customBreakpointsMax.mobile]: {
                      flexDirection: "column",
                      gap: "20px",
                    },
                  }}
                >
                  <Button variant="contained" component={Link} to="/">
                    Go to Home Page
                  </Button>
                </Box>
              </Box>
              <AssistanceLaptop />
            </Box>
          </Box>
        </Box>
      </Container>
      <ResponsiveCTAs />
      <Footer />
    </React.Fragment>
  );
};
